const getFirstErrorValue = (errorData) => {
  if (errorData == null) {
    return ''
  }

  if (typeof errorData === 'string') {
    return errorData
  }

  if (Array.isArray(errorData)) {
    return errorData.join(' ')
  }

  if (typeof errorData === 'object') {
    const firstValue = Object.values(errorData)[0]
    return getFirstErrorValue(firstValue)
  }

  return ''
}

export const getApiErrorMessage = (error, fallbackMessage) => {
  return getFirstErrorValue(error?.response?.data) || fallbackMessage
}

export const getApiFieldErrorMessage = (errorData, fieldName) => {
  return getFirstErrorValue(errorData?.[fieldName])
}